import { StrictMode, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AudioPlayer } from "@/components/AudioPlayer";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import NewsletterUnsubscribe from "@/pages/NewsletterUnsubscribe";
import NewsPage, { NewsArticle } from "@/pages/NewsPage";

function App() {
  useEffect(() => {
    document.title = "AJDR Factory — Centre Artistique Hip-Hop · Albi depuis 1996";
  }, []);
  return (
    <div className="App bg-ink text-cream min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/newsletter/desabonnement" element={<NewsletterUnsubscribe />} />
            <Route path="/actus" element={<NewsPage />} />
            <Route path="/actus/:slug" element={<NewsArticle />} />
          </Routes>
          <AudioPlayer />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
